import React, {useCallback, useMemo} from "react";
import Video from "../../../devices-rows/camera/Video";
import useCameraPresence from "../../../devices-rows/camera/useCameraPresence";
import {useSelector} from "react-redux";
import NewIOT from "../../../../IOT/NewIOT";
import useMQTTFetcher from "../../../../hooks/useMQTTFetcher";
import {getShadows} from "../../../../selectors/shadowSelectors";
import {normalizeStreamObject} from "../../../../selectors/device-rows/cameraSelector";

const CameraContent = ({device, selectStreamId, pip}) => {
    const shadows = useSelector(getShadows);

    const shadow = device?.DevID ? shadows.get(device.DevID) : null;

    const handleHide = useCallback(() => {
        if (selectStreamId) {
            selectStreamId(null);
        }
    }, [selectStreamId]);

    const selected = useMemo(() => {
        if (!device) return null;
        return normalizeStreamObject({device, shadow});
    }, [device, shadow]);

    const fetchData = useCallback(() => {
        if (device) {
            NewIOT.startSendingDeviceState(device);
        }
    }, [device]);

    useMQTTFetcher(fetchData);

    useCameraPresence(
        selected?.gatewayId ?? null,
        selected?.streamId ?? null,
        selected?.streamUrl ?? null
    );

    if (!selected) {
        return null;
    }

    return (
        <Video
            streamId={selected.streamId}
            forcePictureInPicture={pip ?? true}
            isStreamLive={selected.isStreamLive}
            onCloseClick={handleHide}
        />
    );
};

export default CameraContent;
